import { axios } from "@/client/libs/axios";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { FilterRateType, RateDto } from "libs/dto/src/rate";
import qs from "qs";

const getAllRates = async (page?: number, filter?: FilterRateType | null) => {
  if (filter) {
    const responses = await axios.get<
      { page: number; data: RateDto[] },
      AxiosResponse<{ page: number; data: RateDto[] }>,
      { page?: number }
    >("rates/", {
      params: {
        page: page,
        ...filter,
      },
      paramsSerializer: (params) => qs.stringify(params),
    });
    return responses.data;
  }
  const responses = await axios.get<
    { page: number; data: RateDto[] },
    AxiosResponse<{ page: number; data: RateDto[] }>,
    { page?: number }
  >("rates/", {
    params: { page: page },
  });
  return responses.data;
};

export const useRates = (page?: number, filter?: FilterRateType | null) => {
  const {
    data: rates,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["all-rate", page, filter],
    queryFn: () => getAllRates(page, filter),
  });
  return { rates, error, isLoading };
};

export const useRatePay = (enabled: boolean, page?: number, filter?: FilterRateType | null) => {
  const {
    data: rates,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["all-rate"],
    queryFn: () => getAllRates(page, filter),
    enabled: enabled,
  });
  return { rates, error, isLoading };
};
